import React from 'react';
import Create from '../../models/validation/Create';
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function CreateValidation(props) {

    const { t } = useTranslation();

    return (
        <div>
            <br />
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to={'/home/'}>{t("Home_Breadcrumb_Title")}</Link></li>
                    <li className="breadcrumb-item"><Link to={'/Validations/'}>{t("Validation_Breadcrumb_Title")}</Link></li>
                    <li className="breadcrumb-item active">{t("Validation_CreateValidation_Breadcrumb_Title")}</li>
                </ol>
            </nav>
            <br />
            <Create />
            <br />
            <br />
        </div >
    );

}
